var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDocuments(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "\r\n    Documents\r\n  ") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.3339844,0 L20,4.7011719 L20,17 L17,17 L17,20 L0,20 L0,3 L3,3 L3,0 L15.3339844,0 Z M15.5,18.5 L15.5,8.3193359 L11.7089844,4.5 L1.5,4.5 L1.5,18.5 L15.5,18.5 Z M18.5,15.5 L18.5,5.3193359 L14.7089844,1.5 L4.5,1.5 L4.5,3 L12.3339844,3 L17,7.7011719 L17,15.5 L18.5,15.5 Z M4.5,15.0830078 L12.5,15.0830078 L12.5,16.5830078 L4.5,16.5830078 L4.5,15.0830078 Z M4.5,11.25 L12.5,11.25 L12.5,12.75 L4.5,12.75 L4.5,11.25 Z M4.5,7.4169922 L12.5,7.4169922 L12.5,8.9169922 L4.5,8.9169922 L4.5,7.4169922 Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocuments);
export default __webpack_public_path__ + "static/media/documents.254cb0520bdbe7ed96e70f7e2967fc0b.svg";
export { ForwardRef as ReactComponent };